import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoverageEffectiveDateService } from './coverage-effective-date.service';

//TODO remove after temp move has been finished
const qleEndpoint = `/api/product_changes/qle/`;

@Injectable({
  providedIn: 'root',
})
export class QLEService {
  constructor(
    private http: HttpClient,
    public coverageEffectiveDateService: CoverageEffectiveDateService,
  ) {}

  isGetStartedPristine = true;

  public updateGetStartedPristine(pristineVal: boolean): void {
    this.isGetStartedPristine = pristineVal;
  }

  public fetchEffectiveDate(
    qle_id: string,
    qle_date: string,
    enrollment_period?: string,
  ): Observable<any> {
    const endpoint = `/api/product_changes/qle/${qle_id}/effective_date/`;

    const params = { qle_date, enrollment_period };
    return this.http.get(endpoint, { params });
  }

  fetchQLEList(enrollment_period: string, state = '') {
    const params = { enrollment_period, state };

    return this.http.get(qleEndpoint, { params });
  }
}
